/**
 * Watch & Learn Video
 * Ported from the US theme's `customVideo` component (assets/global.js),
 * registered under a unique tag/class names because this theme already
 * defines its own (YouTube-only, shadow-DOM) `custom-video` element that
 * would otherwise silently take over rendering here.
 */
class WatchLearnVideo extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('.wlv-video-container');
    this.contentSection = this.querySelector('.wlv-content-section');

    this.triggerVideo = this.container?.querySelector('[data-trigger-video]');
    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');

    this.videoSection = this.querySelector('.wlv-video-section');
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    if (this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if (this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  focusOut(event) {
    if (this.placementType == 'popup' && this.container.classList.contains('wlv-playing-video')) this.toggleView();
  }

  toggleView(evt) {
    let isOpen = this.container.classList.contains('wlv-playing-video');
    if (isOpen) {
      this.videoSection.innerHTML = '';
      this.container.classList.remove('wlv-playing-video');
    } else {
      if (typeof YT == 'undefined' && this.type == 'youtube') {
        let youtubeScript = document.createElement('script');
        youtubeScript.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(youtubeScript);
      }

      const videoElement = this._buildVideo();
      videoElement.id = 'watch-learn-video' + Math.floor(Math.random() * 100 + 1);
      this.videoSection.appendChild(videoElement);

      const addClassInterval = setInterval(() => {
        if (this.videoSection.innerHTML != '') {
          this.container.classList.add('wlv-playing-video');
          clearInterval(addClassInterval);
        }
      }, 500);
    }
  }

  _buildVideo() {
    let video;

    if (this.type == 'local') {
      video = document.createElement('video');
      video.src = this.videoURL;
      video.controls = this.dataset.controls;
      video.muted = this.dataset.muted;
      video.autoplay = this.dataset.autoplay;
      video.loop = this.dataset.loop;
      video.setAttribute('controlsList', 'nodownload');
    } else if (this.type == 'youtube') {
      let videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement('iframe');
      video.setAttribute('allowfullscreen', '');
      video.setAttribute('allow', 'autoplay');
      video.setAttribute('frameborder', '0');
      video.setAttribute(
        'src',
        'https://www.youtube.com/embed/' +
          videoID +
          `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&muted=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}`
      );
    } else if (this.type == 'vimeo') {
      let videoID = this.videoURL.replace('https://vimeo.com/', '');
      video = document.createElement('iframe');
      video.setAttribute('allowfullscreen', '');
      video.setAttribute('frameborder', '0');
      if (this.dataset.autoplay) video.setAttribute('allow', 'autoplay');
      video.setAttribute(
        'src',
        'https://player.vimeo.com/video/' +
          videoID +
          `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}`
      );
    }
    return video;
  }
}

customElements.define('watch-learn-video', WatchLearnVideo);
